import React from 'react';
import Article from '../../styled-components/Article';
import Hand from '../../styled-components/Hand';
import Description from '../../styled-components/Description';
import CenteredWrapper from '../../styled-components/CenteredWrapper';
import P from '../../styled-components/P';
import H2 from '../../styled-components/H2';
import catalolystBg from '../../img/bg-catalolyst.jpg';
import invertedCurved from '../../img/inverted-curved.svg';
import marked from 'marked';

class OldCatalyst extends React.Component {
  render() {
    const description = marked(this.props.description);
    return (
      <Article bg={catalolystBg}>
        <Hand src={invertedCurved} top="20%" left="0" hideOnMobile />
        <H2 light>{this.props.title}</H2>

        <CenteredWrapper withImage>
          <Description light dangerouslySetInnerHTML={{ __html: description}} />
          <img src={this.props.image} />
        </CenteredWrapper>
      </Article>
    )
  }
};

export default OldCatalyst;



// WEBPACK FOOTER //
// ./src/components/OldCatalyst/index.js